import {autoRegister} from "../container";

@autoRegister()
export class FeatureDetector {
    public isTouchDevice(): boolean {
        return matchMedia("(pointer:coarse)").matches;
    }

    public isDesktopDevice(): boolean {
        return !this.isTouchDevice();
    }
}